__webpack_require__.p = "/RandomQuoteMachine/";